import { Component, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { HistorySearchOptions } from '../../../core/gb-api';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-history-options',
  templateUrl: './history-options.component.html',
  styleUrls: ['./history-options.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => HistoryOptionsComponent), multi: true }],
  imports: [CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class HistoryOptionsComponent implements OnInit, ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() heading = 'Zustand';

  model: HistorySearchOptions;
  propagateChange: (id: string) => void;

  propagateTouch: (_) => void;

  constructor() {}

  ngOnInit() {}

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
